/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  DestroyedFleets,
  DestroyedFleetsParams,
  Fleet,
  FleetInput,
  FleetOptions,
  FleetOptionsParams,
  Fleets,
  FleetsParams,
  RestoreDestroyedFleetParams,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Destroyed Fleets list
 */
export const destroyedFleets = (
    params?: MaybeRefOrGetter<DestroyedFleetsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<DestroyedFleets>(
      {url: `/destroyed-fleets`, method: 'GET',
        params, signal
    },
      );
    }




export const getDestroyedFleetsQueryKey = (params?: MaybeRefOrGetter<DestroyedFleetsParams>,) => {
    return [
    'destroyed-fleets', ...(params ? [params] : [])
    ] as const;
    }


export const getDestroyedFleetsQueryOptions = <TData = Awaited<ReturnType<typeof destroyedFleets>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<DestroyedFleetsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof destroyedFleets>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getDestroyedFleetsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof destroyedFleets>>> = ({ signal }) => destroyedFleets(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof destroyedFleets>>, TError, TData>
}

export type DestroyedFleetsQueryResult = NonNullable<Awaited<ReturnType<typeof destroyedFleets>>>
export type DestroyedFleetsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Destroyed Fleets list
 */

export function useDestroyedFleets<TData = Awaited<ReturnType<typeof destroyedFleets>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<DestroyedFleetsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof destroyedFleets>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDestroyedFleetsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Restore a destroyed fleet
 */
export const restoreDestroyedFleet = (
    id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<RestoreDestroyedFleetParams>,
 signal?: AbortSignal
) => {
      id = toValue(id);
params = toValue(params);

      return axiosClient<Fleet>(
      {url: `/destroyed-fleets/${id}/restore`, method: 'POST',
        params, signal
    },
      );
    }




export const getRestoreDestroyedFleetMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreDestroyedFleet>>, TError,{id: string;params?: RestoreDestroyedFleetParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof restoreDestroyedFleet>>, TError,{id: string;params?: RestoreDestroyedFleetParams}, TContext> => {

const mutationKey = ['restoreDestroyedFleet'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof restoreDestroyedFleet>>, {id: string;params?: RestoreDestroyedFleetParams}> = (props) => {
          const {id,params} = props ?? {};

          return  restoreDestroyedFleet(id,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RestoreDestroyedFleetMutationResult = NonNullable<Awaited<ReturnType<typeof restoreDestroyedFleet>>>

    export type RestoreDestroyedFleetMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Restore a destroyed fleet
 */
export const useRestoreDestroyedFleet = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreDestroyedFleet>>, TError,{id: string;params?: RestoreDestroyedFleetParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof restoreDestroyedFleet>>,
        TError,
        {id: string;params?: RestoreDestroyedFleetParams},
        TContext
      > => {
      return useMutation(getRestoreDestroyedFleetMutationOptions(options), queryClient);
    }
    /**
 * @summary Create Fleet
 */
export const createFleet = (
    fleetInput: MaybeRefOrGetter<FleetInput>,
 signal?: AbortSignal
) => {
      fleetInput = toValue(fleetInput);

      return axiosClient<Fleet>(
      {url: `/fleets`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fleetInput, signal
    },
      );
    }




export const getCreateFleetMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleet>>, TError,{data: FleetInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFleet>>, TError,{data: FleetInput}, TContext> => {

const mutationKey = ['createFleet'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFleet>>, {data: FleetInput}> = (props) => {
          const {data} = props ?? {};

          return  createFleet(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFleetMutationResult = NonNullable<Awaited<ReturnType<typeof createFleet>>>
    export type CreateFleetMutationBody = FleetInput
    export type CreateFleetMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Create Fleet
 */
export const useCreateFleet = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleet>>, TError,{data: FleetInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createFleet>>,
        TError,
        {data: FleetInput},
        TContext
      > => {
      return useMutation(getCreateFleetMutationOptions(options), queryClient);
    }
    /**
 * @summary Fleets list
 */
export const fleets = (
    params?: MaybeRefOrGetter<FleetsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<Fleets>(
      {url: `/fleets`, method: 'GET',
        params, signal
    },
      );
    }




export const getFleetsQueryKey = (params?: MaybeRefOrGetter<FleetsParams>,) => {
    return [
    'fleets', ...(params ? [params] : [])
    ] as const;
    }


export const getFleetsQueryOptions = <TData = Awaited<ReturnType<typeof fleets>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<FleetsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleets>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleets>>> = ({ signal }) => fleets(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleets>>, TError, TData>
}

export type FleetsQueryResult = NonNullable<Awaited<ReturnType<typeof fleets>>>
export type FleetsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleets list
 */

export function useFleets<TData = Awaited<ReturnType<typeof fleets>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<FleetsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleets>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Fleet Options
 */
export const fleetOptions = (
    params?: MaybeRefOrGetter<FleetOptionsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<FleetOptions>(
      {url: `/fleets/options`, method: 'GET',
        params, signal
    },
      );
    }




export const getFleetOptionsQueryKey = (params?: MaybeRefOrGetter<FleetOptionsParams>,) => {
    return [
    'fleets','options', ...(params ? [params] : [])
    ] as const;
    }


export const getFleetOptionsQueryOptions = <TData = Awaited<ReturnType<typeof fleetOptions>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<FleetOptionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetOptions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetOptionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetOptions>>> = ({ signal }) => fleetOptions(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetOptions>>, TError, TData>
}

export type FleetOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof fleetOptions>>>
export type FleetOptionsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Options
 */

export function useFleetOptions<TData = Awaited<ReturnType<typeof fleetOptions>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<FleetOptionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetOptions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetOptionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Destroy Fleet
 */
export const destroyFleet = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Fleet>(
      {url: `/fleets/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyFleetMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleet>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyFleet>>, TError,{id: string}, TContext> => {

const mutationKey = ['destroyFleet'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyFleet>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  destroyFleet(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyFleetMutationResult = NonNullable<Awaited<ReturnType<typeof destroyFleet>>>

    export type DestroyFleetMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Destroy Fleet
 */
export const useDestroyFleet = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleet>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyFleet>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDestroyFleetMutationOptions(options), queryClient);
    }
    /**
 * @summary Fleet Detail
 */
export const fleet = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Fleet>(
      {url: `/fleets/${id}`, method: 'GET', signal
    },
      );
    }




export const getFleetQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',id
    ] as const;
    }


export const getFleetQueryOptions = <TData = Awaited<ReturnType<typeof fleet>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleet>>> = ({ signal }) => fleet(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleet>>, TError, TData>
}

export type FleetQueryResult = NonNullable<Awaited<ReturnType<typeof fleet>>>
export type FleetQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Detail
 */

export function useFleet<TData = Awaited<ReturnType<typeof fleet>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleet>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Fleet
 */
export const updateFleet = (
    id: MaybeRefOrGetter<string>,
    fleetInput: MaybeRefOrGetter<FleetInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
fleetInput = toValue(fleetInput);

      return axiosClient<Fleet>(
      {url: `/fleets/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: fleetInput, signal
    },
      );
    }




export const getUpdateFleetMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleet>>, TError,{id: string;data: FleetInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateFleet>>, TError,{id: string;data: FleetInput}, TContext> => {

const mutationKey = ['updateFleet'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFleet>>, {id: string;data: FleetInput}> = (props) => {
          const {id,data} = props ?? {};

          return  updateFleet(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFleetMutationResult = NonNullable<Awaited<ReturnType<typeof updateFleet>>>
    export type UpdateFleetMutationBody = FleetInput
    export type UpdateFleetMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Update Fleet
 */
export const useUpdateFleet = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleet>>, TError,{id: string;data: FleetInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateFleet>>,
        TError,
        {id: string;data: FleetInput},
        TContext
      > => {
      return useMutation(getUpdateFleetMutationOptions(options), queryClient);
    }
